import {
    Box,
    Tab,
    Grid,
    Tabs,
    Modal,
    Button,
    Divider,
    TextField,
    IconButton,
    Typography,
    Autocomplete,
    CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import config_settings from "../../../config/config";
import CreateCategoryModal from "./CreateCategoryModal";
import uuid from "react-uuid";
import { apiCall } from "../../../utils/action";
import { updateCategoryData } from "../../../store/action";
import { useDispatch } from "react-redux";
import { timestamp } from "../../../utils/services";
import { useSelector } from "react-redux";
import { UpdateTemplateReq } from "../../templateListView/action";


let BASE_URL;

const origin = () => {
    let origin = window.location.origin.toLowerCase();
    if (origin.includes("https://")) origin = origin.replace("https://", "");
    else origin = origin.replace("http://", "");
    BASE_URL = config_settings[origin]?.SERVER_URL;
};

origin();


const AddNewCategoryHT = ({
    open,
    onClose,
    onApply,
    createNewSite, HandleCreateSite, innerTemplate, actions, title, type, currentTemplateId, onModalClose,
    companyKey,
    LoadList,
    AllCategoryList,
    templateDetails,
    updateTemplate,
    requestUpdate
}) => {
    const [templateList, setTemplateList] = useState([]);
    const [openCreateCategoryModal, setOpenCreateCategoryModal] = useState(false);
    const [adding, setAdding] = useState(false);
    const resolvedCurrentTemplateId = templateDetails?.id ?? currentTemplateId;
    const [selectedTemplate, setSelectedTemplate] = useState(resolvedCurrentTemplateId);
    const [categories, setCategories] = useState({ standard: [], optional: [] });
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [tabValue, setTabValue] = useState(0);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const [loadingCategories, setLoadingCategories] = useState(false);
    
    const dispatch = useDispatch();
    const token = sessionStorage.getItem("token");

    const resetSelections = () => {
        setSelectedCategories([]);
        // If you want to reset template too, uncomment:
        // setSelectedTemplate(null);
    };

    const closeModal = () => {
        onModalClose();
        setSelectedCategories([]);
    }
    const addNewBlankCategoryViaFullUpdate = async (categoryName = "") => {
          if (requestUpdate) {
            await requestUpdate();
        }
        return new Promise((resolve, reject) => {
            const existingOrders = (AllCategoryList?.template?.categories || [])
                .map((cat) => Number(cat.order))
                .filter((order) => !Number.isNaN(order));
            const nextOrder = (existingOrders.length ? Math.max(...existingOrders) : 0) + 1;
            const newCategory = {
                uuid: uuid(),
                prompt: categoryName,
                introductory_text: null,
                is_selected: false,
                order: nextOrder,
                is_deleted: 0,
                updated_at: timestamp(),
            };

            const updatedCategories = [
                ...(AllCategoryList?.template?.categories || []),
                newCategory,
            ];
            const updatePayload = {
                ...AllCategoryList,
                template: {
                    ...AllCategoryList?.template,
                    categories: updatedCategories, // full categories list
                    updated_at: timestamp(),
                },
            };
            const uuId = sessionStorage.getItem("user_id");
            const companyId = sessionStorage.getItem("company_id");
            const roleId = sessionStorage.getItem("role_id");
            setAdding(true);
            apiCall(
                (response) => {
                    const { status_code, data, message, success } = response.data;

                    if (success) {
                        // setLoad((prev) => prev + 1);
                        resolve("finished");

                        onModalClose();
                        setAdding(false);
                        LoadList();
                        actions?.CloseAllCategories?.();
                    } else {
                        // toast.error(message);

                        if (status_code === 404) {
                            // navigate(`/templates/`);
                        } else if (
                            status_code === 400 &&
                            message === "You can't edit template details after published."
                        ) {
                            // navigate(`/templates/`);
                        }
                        reject(new Error(message));
                    }
                },
                {
                    // user_id: uuId,
                    // company_id: companyId,
                    // role_id: roleId,
                    // template_id: updatePayload.template.id,
                    // name: updatePayload.template.name,
                    // // description: updatePayload.template.description,
                    // inspection_type_id: updatePayload.template.inspection_type_id,
                    // // default: defaultRef.current,
                    // is_active: updatePayload.template.is_active,
                    // line_level_rating: updatePayload.template.line_level_rating,
                    // updated_at: timestamp(),

                    // // 🔥 Added categories for full update
                    // categories: updatedCategories,
                    ...updatePayload,
                },
                "UPDATE_TEMPLATE_DATA"
            );
        });
    };


    // ------------------------------
    // FETCH TEMPLATE LIST
    // ------------------------------
    const getTemplates = async () => {
        setLoadingTemplates(true);
        try {
            const res = await fetch(
                `${BASE_URL}/templates?skip&get_only_active=1&include_texas=1`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                }
            );
            const data = await res.json();
            const rawList = data?.data || [];
            const hasCurrentTemplate = rawList.some((t) => String(t.id) === String(resolvedCurrentTemplateId));
            const combinedList = hasCurrentTemplate
                ? rawList
                : [{ id: resolvedCurrentTemplateId, name: templateDetails?.name }, ...rawList];
            const seenIds = new Set();
            const dedupedList = combinedList
                .filter((t) => {
                    const key = String(t.id);
                    if (seenIds.has(key)) return false;
                    seenIds.add(key);
                    return true;
                })
                .map((t, index) => ({
                    ...t,
                    optionKey: `${t.id || "template"}-${index}`,
                }));
            setTemplateList(dedupedList);
        } catch (err) {
            console.error("Template API error:", err);
        }
        setLoadingTemplates(false);
    };

    // ------------------------------
    // FETCH CATEGORY LIST
    // ------------------------------
    const getCategories = async (template_id) => {
        setLoadingCategories(true);
        try {
            const res = await fetch(
                `${BASE_URL}/get-categories?template_id=${template_id}`,
                {
                    method: "GET",
                    headers: {
                        "company-key": companyKey,
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                }
            );

            const data = await res.json();

            setCategories({
                standard: data?.data?.standard || [],
                optional: data?.data?.optional || [],
            });
        } catch (err) {
            console.error("Category API error:", err);
        }
        setLoadingCategories(false);
    };


    // Load templates initially
    useEffect(() => {
        if (createNewSite) getTemplates();
    }, [createNewSite]);

    // Pre-select the current template whenever the modal is opened
    useEffect(() => {
        if (createNewSite) setSelectedTemplate(resolvedCurrentTemplateId);
    }, [createNewSite, resolvedCurrentTemplateId]);

    // Load categories whenever template changes
    useEffect(() => {
        if (selectedTemplate) getCategories(selectedTemplate);
    }, [selectedTemplate]);

    // Always load categories from current template if no template selected
    useEffect(() => {
        if (createNewSite) {
            if (!selectedTemplate) {
                getCategories(resolvedCurrentTemplateId);
            }
        }
    }, [createNewSite, selectedTemplate]);


    const existingCategoryNames = new Set(
        (AllCategoryList?.template?.categories || [])
            .filter(c => !c.is_deleted)
            .map(c => (c.prompt || "").trim().toLowerCase())
    );

    const isAlreadyImported = (cat) => {
        const name = (cat.prompt || cat.name || "").trim().toLowerCase();
        return name && existingCategoryNames.has(name);
    };

    // Handle category selection — already-imported categories are not selectable
    const toggleCategory = (cat) => {
        if (selectedCategories.includes(cat.id)) {
            setSelectedCategories(selectedCategories.filter((x) => x !== cat.id));
        } else {
            setSelectedCategories([...selectedCategories, cat.id]);
        }
    };


    const importCategories = async () => {
        for (const catId of selectedCategories) {
            const categoryObj = [
                ...categories.optional,
                ...categories.standard
            ].find(c => c.id === catId);

            if (!categoryObj) continue;

            try {
                await fetch(`${BASE_URL}/import-category`, {
                    method: "POST",
                    headers: {
                        "company-key": companyKey,
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        category_id: categoryObj.id,
                        uuid: categoryObj.uuid,                     // <-- from API response
                        source_template_id: selectedTemplate,       // template user selected
                        target_template_id: resolvedCurrentTemplateId,      // template being edited
                    }),
                });
            } catch (err) {
                console.error("Error importing category:", err);
            }
        }
    };

    return (
        <Modal open={createNewSite}
            onClose={closeModal}>
            <Box
                sx={{
                    width: "824px",
                    height: "624px",
                    bgcolor: "#fff",
                    borderRadius: 1,
                    position: "absolute",
                    borderColor: "#fff !important",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    outline: "none !important",
                    border: "none !important",
                    boxShadow: "none !important",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* ---------------- HEADER ---------------- */}
                <Grid container alignItems="center">
                    <Grid item xs={11} sx={{ p: 2 }}>
                        <Typography className="heading-text">
                            Add categories
                        </Typography>
                    </Grid>
                    <Grid item xs={1} textAlign="right">
                        <IconButton onClick={() => onModalClose()}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} sx={{ p: 2 }}>
                        {/* ---------------- TEMPLATE DROPDOWN ---------------- */}
                        <Typography className="heading-typo">
                            TEMPLATE
                        </Typography>
                        {loadingTemplates ? (
                            <CircularProgress size={28} />
                        ) : (
                            <Box className="autocomplete-wrapper" sx={{ position: "relative" }}>
                                <Autocomplete
                                    options={templateList}
                                    value={templateList.find(t => String(t.id) === String(selectedTemplate)) || null}
                                    filterOptions={(options, { inputValue }) => {
                                        const trimmedInput = inputValue?.trim()?.toLowerCase();
                                        if (!trimmedInput) return options;
                                        return options?.filter((option) =>
                                        (option?.name || "").trim().toLowerCase().includes(trimmedInput)
                                        );
                                    }}
                                    onChange={(event, newValue) => {
                                        setSelectedTemplate(newValue ? newValue.id : "");
                                    }}
                                    getOptionKey={(option) => option?.optionKey}
                                    getOptionLabel={(option) => (String(option.id) === String(resolvedCurrentTemplateId) ? `Current template (${option?.name})` : option.name)}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {String(option.id) === String(resolvedCurrentTemplateId)
                                                ? `Current template (${option?.name?.trim() || "Untitled"})`
                                                : option?.name?.trim() || "Untitled"}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            placeholder="Select template"
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    paddingRight: "55px !important", // space for clear + arrow
                                                },
                                            }}
                                        />
                                    )}
                                    componentsProps={{
                                        popper: {
                                            sx: {
                                                "& .MuiAutocomplete-paper": {
                                                    maxHeight: 300,
                                                    overflowY: "auto",
                                                },
                                            },
                                        },
                                    }}
                                />
                                {/* CLEAR BUTTON — hover only */}
                                {selectedTemplate && (
                                    <IconButton
                                        size="small"
                                        // className="hover-clear-btn"
                                        onClick={() => setSelectedTemplate("")}
                                        sx={{
                                            position: "absolute",
                                            right: 32,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            opacity: 0,
                                            transition: "0.2s",
                                            padding: "2px",
                                            zIndex: 3,
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>

                {/* ---------------- TABS ---------------- */}
                <Box sx={{ p: 2, mt: -2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={(e, v) => setTabValue(v)}
                        sx={{ borderBottom: "1px solid #ddd", fontFamily: '"Source Sans Pro", sans-serif !important', }}
                    >
                        <Tab label={<Typography className="tabs-typo">Optional</Typography>} />
                        <Tab label={<Typography className="tabs-typo">Standard</Typography>} />
                    </Tabs>
                </Box>

                {/* ---------------- CATEGORY LIST ---------------- */}
                <Box sx={{ p: 2, flexGrow: 1, overflow: "hidden" }}>
                    {tabValue === 0 && (
                        <Box
                            sx={{
                                display: "flex",
                                p: 1.5,
                                alignItems: "center",
                                border: "1px solid #ddd",
                                fontFamily: '"Source Sans Pro", sans-serif !important',
                                borderRadius: "9px",
                                fontSize: "17px",
                                gap: 1,
                                mb: 2,
                                cursor: "pointer",
                                fontWeight: 500,
                            }}
                            onClick={() => setOpenCreateCategoryModal(true)}
                        >
                            <AddCircleOutlineIcon color="primary" />
                            Create new category
                        </Box>
                    )}
                    <Box
                        sx={{
                            maxHeight: tabValue === 0 ? 245 : 310,
                            overflowY: "auto",
                            pr: 1,
                        }}
                    >
                        {loadingCategories ? (
                            <CircularProgress size={28} />
                        ) : (
                            <>
                                {tabValue === 0 && categories.optional.length === 0 && (
                                    <Typography sx={{ textAlign: "center", color: "#999" }}>
                                        No optional category found
                                    </Typography>
                                )}

                                {tabValue === 1 && categories.standard.length === 0 && (
                                    <Typography sx={{ textAlign: "center", color: "#999" }}>
                                        No standard category found
                                    </Typography>
                                )}

                                {(tabValue === 0 ? categories.optional : categories.standard).map(
                                    (cat) => {
                                        const selected = selectedCategories.includes(cat.id);
                                        // const alreadyImported = isAlreadyImported(cat);
                                        return (
                                            <Box
                                                key={cat.id}
                                                onClick={() => toggleCategory(cat)}
                                                sx={{
                                                    p: 1.5,
                                                    borderRadius: "9px",
                                                    border: "1px solid #ddd",
                                                    mb: 1,
                                                    background: selected ? "#e8f2ff" : "#fff",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    minHeight: 48,
                                                    cursor:"pointer"
                                                }}
                                            >
                                                <Grid container alignItems="center">
                                                    <Grid item xs={10.5}>
                                                        <Typography className="list-typo" sx={{ color: "inherit" }}>
                                                            {cat.prompt || cat.name || "Untitled"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={1.5} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <CheckIcon color="primary" sx={{ visibility: selected ? "visible" : "hidden" }} />
                                                    </Grid>
                                                    {/* {alreadyImported ? <Grid item xs={1.5} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}> <Typography sx={{ fontSize: "12px", color: "#999", fontStyle: "italic" }}>
                                                        Already added
                                                    </Typography></Grid> : null} */}
                                                </Grid>
                                            </Box>
                                        );
                                    }
                                )}
                            </>
                        )}
                    </Box>

                </Box>
                {/* ---------------- FOOTER BUTTONS ---------------- */}
                <Grid container justifyContent="flex-end" gap={2} p={2}>
                    <Button variant="text" className="inspection-filter-modal-buttons-cancel" sx={{ width: "101px" }} onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        disabled={adding || selectedCategories?.length === 0}
                        className="inspection-filter-modal-buttons-apply"
                        sx={{ width: "84px" }}
                        onClick={async () => {
                            await updateTemplate("noToast");
                            setAdding(true);
                            await importCategories();
                            setSelectedCategories([]);
                            await actions?.AddSiteDetaill?.();
                            actions?.CloseAllCategories?.();
                            setAdding(false);
                            LoadList();
                            onModalClose();
                        }}
                    >
                        {adding ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Add"}
                    </Button>
                </Grid>
                <CreateCategoryModal
                    open={openCreateCategoryModal}
                    onClose={() => setOpenCreateCategoryModal(false)}
                    HandleCreateSite={HandleCreateSite}
                    actions={actions}
                    adding={adding}
                    setAdding={setAdding}
                    CreateAddCategory={addNewBlankCategoryViaFullUpdate}
                    onSave={() => {
                        setOpenCreateCategoryModal(false); // Close the modal
                        // CreateAddCategory();                // ✅ Trigger blank category + API call
                    }}
                />
            </Box>
        </Modal>
    );
};

export default AddNewCategoryHT;
